/**
 * LoadingRenderer — animated typing-dots placeholder. Used both for our
 * own optimistic streaming bubble (before the first delta arrives) and for
 * server-emitted `loading` content items (a tool-side placeholder while a
 * longer-running operation resolves).
 */
import React from 'react';
import type { Renderer } from '../registry';

const LoadingRenderer: Renderer = () => (
  <span className="wg-chat__typing" aria-hidden>
    <span /> <span /> <span />
  </span>
);

export default LoadingRenderer;
